import { Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

interface UploadingHintProps {
  id: string
}

export const UploadingHint = ({ id }: UploadingHintProps) => (
  <Text id={id} variant={TypographyStyles.BODY_XS} color={TextColors.MUTED}>
    Wait for uploads to finish.
  </Text>
)
